import { createContext, type Ref } from 'react'

/**
 * This context provides the position to a nested VBar component.
 */
export interface VBarPositionContext {
  readonly id: string
  /** Top position of the VBar (top of text range) */
  readonly top: number
  /** Left position of the VBar box (left-most margin position) */
  readonly left?: number
  /** Width available to render the VBar (margin width) */
  readonly width?: number
  /** Anchor height of the VBar (the text range height) */
  readonly anchorHeight: number
  /** This must be true for the positioning to be applied */
  readonly isPositioned: boolean
  /** z-index to use for the child */
  readonly zIndex?: number
  /** Optional ref that should be attached to the component */
  readonly ref?: Ref<HTMLElement>
  /** Optional data attributes that should be attached to the component */
  readonly dataset?: Record<`data-${string}`, string>
}

export const VBarPositionContext = createContext<VBarPositionContext>({
  id: '',
  top: 0,
  anchorHeight: 0,
  isPositioned: false,
})
